import axios from 'axios';
import { IFetchNudgeStatusRequest, IFetchSiteListRequest } from '../store/site/types';

export const fetchSiteList = (parms: IFetchSiteListRequest) =>
  axios({
    method: 'POST',
    url: 'cfr-service/health-facility/list',
    data: {
      limit: parms.limit,
      skip: parms.skip,
      countryId: parms.regionId,
      userBased: parms.userBased,
      isHF4User: parms.isHF4User,
      ...(parms.search ? { searchTerm: parms.search } : {})
    }
  });

export const fetchNudgeStatus = (data: Omit<IFetchNudgeStatusRequest, 'type'>) =>
  axios({
    method: 'POST',
    url: 'cfr-service/user/hf4-nudge/status',
    data
  });
